export const ReportCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  flex: '1',
  minWidth: 'E',
  Title: { text: (el, s) => s.title || 'Metric', fontSize: 'Y', color: 'inkMuted', fontWeight: '600', textTransform: 'uppercase', letterSpacing: 'X' },
  Value: { text: (el, s) => s.value || '0', fontSize: 'D', fontWeight: '800', color: 'teal' },
  ComparisonRow: {
    if: (el, s) => !!s.comparisonValue,
    flow: 'x',
    align: 'center flex-start',
    gap: 'X',
    Arrow: {
      text: (el, s) => s.deltaPositive ? '\u25B2' : '\u25BC',
      fontSize: 'Y',
      color: (el, s) => s.deltaPositive ? 'green' : 'red'
    },
    ComparisonValue: {
      text: (el, s) => s.comparisonValue || '',
      fontSize: 'Z',
      fontWeight: '600',
      color: (el, s) => s.deltaPositive ? 'green' : 'red'
    }
  },
  SparklineTrend: {
    flow: 'x',
    align: 'flex-end center',
    gap: '2px',
    height: 'B',
    marginTop: 'Y',
    Dot1: { width: '6px', height: (el, s) => s.spark1 || '40%', background: 'teal', round: 'C' },
    Dot2: { width: '6px', height: (el, s) => s.spark2 || '55%', background: 'teal', round: 'C' },
    Dot3: { width: '6px', height: (el, s) => s.spark3 || '45%', background: 'teal', round: 'C' },
    Dot4: { width: '6px', height: (el, s) => s.spark4 || '70%', background: 'teal', round: 'C' },
    Dot5: { width: '6px', height: (el, s) => s.spark5 || '60%', background: 'teal', round: 'C' },
    Dot6: { width: '6px', height: (el, s) => s.spark6 || '80%', background: 'teal', round: 'C' },
    Dot7: { width: '6px', height: (el, s) => s.spark7 || '90%', background: 'teal', round: 'C' }
  },
  TimePeriod: { text: (el, s) => s.timePeriod || 'Last 7 days', fontSize: 'Y', color: 'inkMuted', marginTop: 'Y' }
}
